import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./auth/AuthProvider";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { MapBridgeProvider } from "./features/map-bridge/MapBridgeContext";
import AppRoutes from "./app/routes";

export default function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <MapBridgeProvider>
          <BrowserRouter>
            <AppRoutes />
            {}
          </BrowserRouter>
        </MapBridgeProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
}
